import { useI18n } from '../../i18n'
import { useScrollAnim } from '../../hooks/use-scroll-anim'
import { PricingTierCard } from './PricingTierCard'
import { Loader2 } from 'lucide-react'
import type { Plan } from '../../types'

interface PricingTierCardsProps {
  plans: Plan[]
  currentPlanCode?: string
  onSelectPlan: (plan: Plan) => void
  loading?: boolean
}

export function PricingTierCards({ plans, currentPlanCode, onSelectPlan, loading }: PricingTierCardsProps) {
  const { t } = useI18n()
  const { ref, isVisible } = useScrollAnim()

  return (
    <section ref={ref} className="pb-8">
      <div className={`transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
        {loading ? (
          <div className="flex items-center justify-center py-12">
            <Loader2 className="h-6 w-6 text-orange-500 animate-spin" />
            <span className="ml-2 text-sm text-gray-400">{t('加载套餐中...', 'Loading plans...')}</span>
          </div>
        ) : plans.length === 0 ? (
          <div className="text-center py-12">
            <p className="text-sm text-gray-400">{t('暂无可用套餐', 'No plans available')}</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {plans
              .sort((a, b) => a.sortOrder - b.sortOrder)
              .map((plan) => (
                <PricingTierCard
                  key={plan.id}
                  plan={plan}
                  onSelect={onSelectPlan}
                  isCurrent={currentPlanCode === plan.planCode}
                />
              ))}
          </div>
        )}
      </div>
    </section>
  )
}
